import Vue from "vue";

import { Component } from "vue-property-decorator";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";
import { modelServices } from "../../scripts/ah.mb.ui.model-services"
import { ModelNotifier } from "../../scripts/model-notifier";
import { bootbox } from "../../infrastructure/bootbox-shim";
import { IUserAccount } from "../../infrastructure/userAccount";
import { MessageBox } from "uiv";

import { State, Action, Getter } from "vuex-class";
import { IState } from "../../infrastructure/state/state-types";
const namespace = "profile";


interface ISiteInfo {
    dbPrefix: string;
    compileDate: Date;
    versionNumber: string;
    convergerInfo: string;
    databaseInfo: string;
}

interface IFileModel {
    fileUrl: string;
    description: string;

}
interface ISiteUpdateInfo {
    areUpdates: boolean;
    updateLinks: IFileModel[];
}

@Component
export default class AppComponent extends Vue {

    @State("profile") profile: IState;
    @Action("fetchData", { namespace: namespace }) fetchData: () => Promise<any>;

    @Action("setCurrentModelId", { namespace: namespace }) setCurrentModelId: any;
    @Action("setCurrentNodePath", { namespace: namespace }) setCurrentNodePath: any;

    @Getter("activeUserName", { namespace: namespace }) activeUserName: string;
    @Getter("activeUser", { namespace: namespace }) activeUser: IUserAccount;

    @Getter("modelIsActive", { namespace: namespace }) modelIsActive: false;
    @Getter("currentModelId", { namespace: namespace }) currentModelId: string;

    @Getter("capabilities", { namespace: namespace }) capabilities: string[];


    // Model change observer
    private modelObserver = new ModelNotifier();
    // Create modelServices
    modelServices = new modelServices(this.modelObserver);

    showConvergeModelDialog: boolean = false;
    modelToConvergeId: string = "";


    siteInfo: ISiteInfo = null;
    showAiAssistant: boolean = false


    getSetInfoDateString() {
        const date = new Date(this.siteInfo.compileDate);
        return date.toDateString();

    }

    mounted() {

        this.$root.$on('activeConvergenceProviderChanged', this.handleActiveConvergenceProviderChanged)

        // Because this is called even when we are not logged in, we don't want a 401 unauthorized error to display
        // Probably a better way to handle this
        this.fetchData()
            .catch(() => { })

        // this.setCurrentModelId("TestModel");

        this.refreshSiteInfo();

        const updateDocKey = "siteUpdates_mostRecentDocUrl";
        var mostRecentSiteUpdateDocName = localStorage[updateDocKey] as string;

        // Don't handle errors in this fetch because it fails if not logged in
        FetchWrapper.fetch(`/api/1.0/siteinfo/getLatestSiteUpdateDoc?mostRecentDocUrl=${mostRecentSiteUpdateDocName}`,
            { method: "get" }, { handleErrors: false })
            .then(response => {
                if (response.ok) {
                    response.json().then((response: ISiteUpdateInfo) => {
                        if (response.areUpdates && response.updateLinks.length > 0) {

                            // We will only get one update link
                            const update = response.updateLinks[0]
                            localStorage[updateDocKey] = update.fileUrl;

                            var updateLinks = response.updateLinks.map(p => `<a href="${p.fileUrl}" target="_blank">${p.description}</a>`);
                            var linksStr = updateLinks.join("<br>");
                            MessageBox.alert({
                                size: "md", html: true, title: "Site Update Notification", content: "<p>Site has been updated since your last visit.</p>"
                                    + "<p>Please view the document(s) below to view information about the changes.  Note: site update notification documents can be viewed later in the help section of the site.</p>"
                                    + linksStr
                            });
                        }
                    })
                }
            });


        const sidebarCollapsed = localStorage["sidebarCollapsed"];
        $("body").toggleClass("sidebar-collapse", sidebarCollapsed === "true");
        $("body").show();



        // On expand, resize controls.  timeout is so the transition has time to finish before resizing.
        $("body").on("expanded.pushMenu", () => {
            localStorage["sidebarCollapsed"] = "false";
            setTimeout(() => {
                // Todo: Fix control sizes on resize
                //tryCallSetControlSizes()
            }, 400);

        });

        // On expand, resize controls.  timeout is so the transition has time to finish before resizing.
        $("body").on("collapsed.pushMenu",
            () => {
                localStorage["sidebarCollapsed"] = "true";
                // Todo: Fix control sizes on resize

                setTimeout(() => {
                    // tryCallSetControlSizes()
                }, 400);

            });

    }

    refreshSiteInfo() {
        // Don't handle errors in this fetch because it fails if not logged in
        FetchWrapper.fetch("/api/1.0/siteInfo/siteinfo", { method: "get" }, { handleErrors: false })
            .then(response => {
                if (response.ok) {
                    response.json().then((siteInfo: ISiteInfo) => { this.siteInfo = siteInfo });
                };
            });
    }

    logout() {
        FetchWrapper.fetch("/accounts/logoff",
            {
                method: "get",
                //                    redirect: "follow"
            })
            .then(() => {
                window.location.reload();
                //               window.location.replace((data as any).redirect);
            });
    }

    convergeModel(modelId: string) {
        this.modelToConvergeId = this.currentModelId;
        this.showConvergeModelDialog = true;

    }

    resetPassword() {
        bootbox.confirm(`Send password reset email to ${this.activeUser.email}?`,
            ok => {
                if (ok) {
                    const payload = { userName: this.activeUser.userName };

                    FetchWrapper.sendCommandAndHandle(`/accounts/sendpasswordreset`,
                        { method: "post", body: JSON.stringify(payload) });

                }
            });
    }

    handleActiveConvergenceProviderChanged() {
        this.refreshSiteInfo();
    }

    toggleAiAssistant() {
        this.showAiAssistant = !this.showAiAssistant;
    }


    checkCapability(capability: string): boolean {
        if (this.profile && this.profile.capabilities)
            return this.profile.capabilities.checkCapability(capability)
        return false;
    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/app/app.ts